import React, { Component } from "react";
import { connect } from "react-redux";
import ReactToPrint from "react-to-print";
import { Card, Typography, CardContent } from "@material-ui/core";
import { StyledHeader } from "../../styles";
import { getReport, getJobPackReports } from "./actions";
import { selectReport, canUpdate } from "./selectors";
import { cellStyle as cs, gridStyle as gs } from "../gridHelper";
import { noSig } from "vrcore-dashboard/dist/utilities";
import PrintIcon from "@material-ui/icons/Print";
class AccidentReportForm extends Component {
    constructor(props) {
        super(props);
        const path = props.location.pathname.split("/");
        if (path[2] === "reports") {
            props.getReport(
                path[2].replace(/-/g, "_"),
                path[3],
                path[5].replace(/_/g, " ").replace(/\./g, ":")
            );
        } else {
            props.getJobPackReports(
                props.match.params.uid,
                path[2].replace(/-/g, "_"),
                path[3],
                path[4].replace(/-/g, "_"),
                path[5].replace(/-/g, "_"),
                props.match.params.report_id
                    .replace(/_/g, " ")
                    .replace(/\./g, ":")
            );
        }
        this.state = {
            title: document.title,
        };
    }
    renderPhotos(attachedPhotos) {
        let photoRow = 2;
        let photoCell = 1;
        return attachedPhotos.map((photo, i) => {
            let photoInfo = (
                <React.Fragment key={i}>
                    <div
                        style={cs(
                            photoRow,
                            photoCell,
                            photoRow,
                            photoCell,
                            true
                        )}
                    >
                        {photo.photo_name}
                    </div>
                    <div
                        style={cs(
                            photoRow,
                            photoCell + 1,
                            photoRow,
                            photoCell + 1,
                            true
                        )}
                    >
                        {photo.photo_timestamp}
                    </div>
                    <div
                        style={cs(
                            photoRow + 1,
                            photoCell,
                            photoRow + 1,
                            photoCell + 2
                        )}
                    >
                        <img
                            src={photo.photo_url}
                            alt="Site "
                            onClick={() => {
                                this.setState({
                                    selectedPhoto: photo,
                                    imageModal: true,
                                });
                            }}
                            style={{
                                width: 300,
                                height: 300,
                                margin: "auto",
                                cursor: "pointer",
                            }}
                        />
                    </div>
                </React.Fragment>
            );
            photoCell += 2;
            if (photoCell === 9) {
                photoRow += 2;
                photoCell = 1;
            }
            return photoInfo;
        });
    }
    render() {
        const { report } = this.props;
        return (
            <Card>
                <StyledHeader style={{ background: "#0188cc" }}>
                    <Typography variant="h5" style={{ color: "white" }}>
                        Accident Report Form
               
                    <ReactToPrint
                        onBeforePrint={() =>
                            (document.title =
                                "Accident Report Form " +
                                this.props.match.params.report_id)
                        }
                        onAfterPrint={() => (document.title = this.state.title)}
                        trigger={() => (
                            <PrintIcon
                            style={{
                                float: "right",
                                fontSize: "36px",
                                marginRight: "30px",
                                cursor:"pointer"
                            }}
                            />
                        )}
                        content={() => this.componentRef}
                    />
                    </Typography>
                     </StyledHeader>
                     <CardContent>
                    {report && (
                        <div ref={(el) => (this.componentRef = el)}>
                            {this.props.header && (
                                <this.props.header
                                    date={this.props.match.params.report_id}
                                    reportType={this.props.reportType}
                                />
                            )}
                            <div style={gs(4, 8)}>
                                <div style={cs(1, 1, 1, 9, false, true)}>
                                    <b>Injured Person Details</b>
                                </div>
                                <div style={cs(2, 1, 2, 5)}>
                                    <b>Name:</b>&nbsp; {report.injured_person_name}
                                </div>
                                <div style={cs(2, 5, 2, 7)}>
                                    <b>Gender:</b>&nbsp; {report.injured_person_gender}
                                </div>
                          
                                <div style={cs(2, 7, 2, 9)}>
                                    <b>Date Of Birth:</b>&nbsp; {report.injured_person_dob}
                                </div>
                         
                                <div style={cs(3, 1, 3, 5)}>
                                    <b>Home Address:</b>&nbsp; {report.injured_person_address}
                                </div>
                               
                                <div style={cs(3, 5, 3, 9)}>
                                    <b>City Council Location:</b>&nbsp; {report.council_location}
                                </div>
                              
                                <div style={cs(4, 1, 4, 3)}>
                                    <b>Date Of Accident:</b>&nbsp; {report.date_of_accident}
                                </div>
                        
                                <div style={cs(4, 3, 4, 5)}>
                                    <b>Time Of Accident: </b>&nbsp; {report.time_of_accident}
                                </div>
                           
                                <div style={cs(4, 5, 4, 7)}>
                                    <b>Time Starting Work:</b>&nbsp; {report.start_work_time}
                                </div>
                              
                                <div style={cs(4, 7, 4, 9)}>
                                    <b>Normal Finishing Time:</b>&nbsp; {report.end_work_time}
                                </div>
                        
                            </div>
                            <div style={gs(2, 8)}>
                                <div style={cs(1, 1, 1, 9, false, true)}>
                                    <b>
                                        To Whom On Site Was Accident Reported To
                                        :
                                    </b>
                                </div>
                                <div style={cs(2, 1, 2, 5)}>
                                    <b>Name:</b>&nbsp; {report.reporter_name}
                                </div>
                              
                                <div style={cs(2, 5, 2, 9)}>
                                    <b>Designation:</b>&nbsp; {report.reporter_designation}
                                </div>
                           
                            </div>
                            <div style={gs(11, 8)}>
                                <div style={cs(1, 1, 1, 9, false, true)}>
                                    <b>Accident Details</b>
                                </div>
                                <div style={cs(2, 1, 2, 9)}>
                                    <b>
                                        Exact Location Of Accident- (to be
                                        inspected as soon as accident is
                                        reported)
                                    </b>
                                </div>
                                <div style={cs(3, 1, 4, 9, true)}>
                                    {report.exact_location_of_accident}
                                </div>
                                <div style={cs(5, 1, 5, 9)}>
                                    <b>
                                        What was person doing at time of
                                        accident:
                                    </b>
                                </div>
                                <div style={cs(6, 1, 7, 9, true)}>
                                    {report.person_actions_during_accident}
                                </div>
                                <div style={cs(8, 1, 8, 9)}>
                                    <b>Describe how the accident occured:</b>
                                </div>
                                <div style={cs(9, 1, 10, 9, true)}>
                                    {report.how_accident_occured}
                                </div>
                                <div style={cs(6, 1, 7, 9, true)}>
                                    {report.person_actions_during_accident}
                                </div>
                                <div style={cs(11, 1, 11, 3)}>
                                    <b>Weather Conditions:</b>
                                </div>
                                <div style={cs(11, 2, 11, 3, true)}>
                                    {report.weather_condition}
                                </div>
                                <div style={cs(11, 3, 11, 9)} />
                            </div>
                            <div style={gs(2, 8)}>
                                <div style={cs(1, 1, 1, 9, false, true)}>
                                    <b>Treatment</b>
                                </div>
                                <div style={cs(2, 1, 2, 5)}>
                                    <b>Treatment Involved:</b>&nbsp; {report.treatment_involved}
                                </div>
                        
                                <div style={cs(2, 5, 2, 9)}>
                                    <b>Treatment Involved Other:</b>&nbsp;      {report.treatment_involved_other === ""
                                        ? "N/A"
                                        : report.treatment_involved_other}
                                </div>
                         
                            </div>
                            <div style={gs(2, 8)}>
                                <div style={cs(1, 1, 1, 9, false, true)}>
                                    <b>Any Other Person Injured</b>
                                </div>
                                <div style={cs(2, 1, 2, 5)}>
                                    <b>Other Person Name:</b>&nbsp;    {report.others_injured_name === ""
                                        ? "N/A"
                                        : report.others_injured_name}
                                </div>
                        
                                <div style={cs(2, 5, 2, 9)}>
                                    <b>Other Person Address:</b>&nbsp;         {report.others_injured_address === ""
                                        ? "N/A"
                                        : report.others_injured_address}
                                </div>
                          
                            </div>
                            <div style={gs(2, 8)}>
                                <div style={cs(1, 1, 1, 9, false, true)}>
                                    <b>Witness Details</b>
                                </div>
                                <div style={cs(2, 1, 2, 5)}>
                                    <b>Witness Name:</b>&nbsp;     {report.witness_name === ""
                                        ? "N/A"
                                        : report.witness_name}
                                </div>
                        
                                <div style={cs(2, 5, 2, 9)}>
                                    <b>Witness Address:</b>&nbsp;       {report.witness_address === ""
                                        ? "N/A"
                                        : report.witness_address}
                                </div>
                        
                            </div>
                            <div style={gs(3, 8)}>
                                <div style={cs(1, 1, 1, 9, false, true)}>
                                    <b>Details Of Notifier</b>
                                </div>
                                <div style={cs(2, 1, 2, 5)}>
                                    <b>Notifier Name:</b>&nbsp;  {report.notifier_name}
                                </div>
                           
                                <div style={cs(2, 5, 2, 9)}>
                                    <b>Notifier Position:</b>&nbsp; {report.notifier_position}
                                </div>
                        
                                <div style={cs(3, 1, 3, 5)}>
                                    <b>Notifier Phone Number:</b>&nbsp; {report.notifier_phone_no}
                                </div>
                              
                                <div style={cs(3, 5, 3, 9)} />
                            </div>
                            <div
                                style={{
                                    display: "flex",
                                    justifyContent: "space-between",
                                }}
                            >
                                <div style={{ width: "49%" }}>
                                    <div style={gs(5, 4)}>
                                        <div
                                            style={cs(1, 1, 1, 4, false, true)}
                                        >
                                            <b>Signature</b>
                                        </div>
                                        <div style={cs(2, 1, 2, 5)}>
                                            <img
                                                src={
                                                    report.signature_url === ""
                                                        ? noSig
                                                        : report.signature_url
                                                }
                                                style={{
                                                    height: 200,
                                                    width: 200,
                                                    margin: "auto",
                                                }}
                                                alt="Signature"
                                            />
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div style={gs(4, 9, null)}>
                                <div style={cs(1, 1, 1, 1, false, true)}>
                                    <b>Attached Photos</b>
                                </div>
                                {report.attached_photos &&
                                    this.renderPhotos(report.attached_photos)}
                            </div>
                        </div>
                    )}
                </CardContent>
            </Card>
        );
    }
}
export default connect(
    (store) => {
        return { report: selectReport(store), canUpdate: canUpdate(store) };
    },
    { getReport, getJobPackReports }
)(AccidentReportForm);
